import { FetchData } from './Request';

export const CRITERIA_CODES = {
  PO_PRICE_TOLERANCE: 'PO_PRICE_TOLERANCE',
};

export const DEFAULT_VALUES = {
  [CRITERIA_CODES.PO_PRICE_TOLERANCE]: 3.0, // 3% default tolerance
};

let criteriaValues = { ...DEFAULT_VALUES };

export const setCriteriaValues = (values) => {
  criteriaValues = { ...DEFAULT_VALUES, ...values };
};

export const getCriteriaValue = (code) => {
  return criteriaValues[code] || DEFAULT_VALUES[code];
};

export const validatePriceDifference = (poPrice, receivePrice) => {
  if (!poPrice || !receivePrice) return true;

  const tolerance = getCriteriaValue(CRITERIA_CODES.PO_PRICE_TOLERANCE);
  const priceDiff = Math.abs(((receivePrice - poPrice) / poPrice) * 100);

  return priceDiff <= tolerance;
};

export const validatePriceDifferencePurchase = (lastPoPrice, newPoPrice) => {
  if (!lastPoPrice) {
    return true;
  }
  const tolerance = getCriteriaValue(CRITERIA_CODES.PO_PRICE_TOLERANCE);
  const priceDiff = Math.abs(((newPoPrice - lastPoPrice) / lastPoPrice) * 100);

  return priceDiff <= tolerance;
};

export const fetchCriteriaValues = async (token) => {
  try {
    const result = await FetchData('GET', '/criteria', token);
    console.log('Fetch criteria API result:', result);
    if (result.status === 'ok') {
      const criteriaMap = {};
      result.data.forEach((item) => {
        criteriaMap[item.code] = parseFloat(item.value);
      });
      console.log('Fetched criteria values:', criteriaMap);
      setCriteriaValues(criteriaMap);
      return criteriaMap;
    }
    return DEFAULT_VALUES;
  } catch (error) {
    console.error('Error fetching criteria values:', error);
    return DEFAULT_VALUES;
  }
};

export const updateCriteriaValue = async (token, id, code, value, description = '') => {
  try {
    const result = await FetchData('PUT', '/criteria', token, {
      id,
      code,
      value,
      description,
    });

    if (result.status === 'ok') {
      const updatedValues = { ...criteriaValues };
      updatedValues[code] = value;
      setCriteriaValues(updatedValues);
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error updating criteria value:', error);
    return false;
  }
};

export const getCriteriaList = async (token) => {
  try {
    const result = await FetchData('GET', '/criteria', token);
    if (result.status === 'ok') {
      return result.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching criteria list:', error);
    return [];
  }
};

export const getCriteriaByCategory = async (token, category) => {
  try {
    const result = await FetchData('OPTIONS', `/criteria/category`, token, {
      category,
    });
    if (result.status === 'ok') {
      return result.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching criteria list:', error);
    return [];
  }
};

export const getCostPOSummary = async (token) => {
  try {
    const result = await FetchData('OPTIONS', `/criteria/cost_po`, token);
    if (result.status === 'ok') {
      return result.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching criteria list:', error);
    return [];
  }
};
